/**
 * Version tracking per CoronaTek CRM
 *
 * IMPORTANTE: Incrementare VERSION e BUILD_DATE ad ogni deploy
 *
 * Format: MAJOR.MINOR.PATCH-TAG
 * - MAJOR: Breaking changes (es. 2.0.0)
 * - MINOR: Nuove features (es. 2.1.0)
 * - PATCH: Bug fixes (es. 2.1.1)
 * - TAG: release/beta/alpha
 */

/**
 * Ambiente di esecuzione, rilevato a runtime dal hostname (2026-07-22):
 * beta.coronacrm.it / *.beta.* → "-beta", tutto il resto → "-dev".
 * Appeso al numero di versione nei footer delle webapp per capire al volo
 * su quale ambiente si sta operando.
 */
export const AMBIENTE =
  typeof window !== 'undefined' && window.location.hostname.includes('beta') ? '-beta' : '-dev';

export const APP_VERSION = {
  VERSION: '5.9.317',
  BUILD_DATE: '2026-02-17T00:00:00Z',
  BUILD_NUMBER: '1771378000000',
  TAG: 'release',
  SERVICE_WORKER: 'v392',
  DESCRIPTION: 'Fix scan line range + clear campo a ogni scan'
};

export const getVersionString = () => {
  return `${APP_VERSION.VERSION}-${APP_VERSION.TAG}`;
};

export const getFullVersionInfo = () => {
  return {
    version: getVersionString(),
    buildDate: new Date(APP_VERSION.BUILD_DATE).toLocaleString('it-IT'),
    buildNumber: APP_VERSION.BUILD_NUMBER,
    serviceWorker: APP_VERSION.SERVICE_WORKER,
    description: APP_VERSION.DESCRIPTION
  };
};
